import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ScopeForm from "../components/Scopes/ScopeForm";
import ScopeInfo from "../components/Scopes/ScopeInfo";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";

const ScopeDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewScope = !id;

  const {data, loading, read, remove} = useApiRequest("/scopes");

  const [isEditing, setIsEditing] = useState(isNewScope);

  useEffect(() => {
    if (!isNewScope) {
      read(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este rol?");
    if (confirmDelete) {
      try {
        await remove(id);
        navigate("/scopes");
      } catch (error) {
        console.error("Error al eliminar el scope:", error);
      }
    }
  };

  return (
    <Window title={isNewScope ? "Nuevo Scope" : "Detalles del Scope"}>
      {loading && !isNewScope ? (
        <CircularProgress />
      ) : (
        <Stack direction="row" spacing={2} justifyContent={"space-between"}>
          {isEditing ? (
            <ScopeForm
              isNew={isNewScope}
              refreshData={() => read(id)}
              setIsEditing={setIsEditing}
              initialScopeData={data}
            />
          ) : (
            <ScopeInfo scope={data} />
          )}
          <Box>
            {!isNewScope &&
              (isEditing ? (
                <Button variant="contained" color="primary" onClick={handleEditToggle}>
                  Cancelar
                </Button>
              ) : (
                <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                  <FiEdit2 />
                </IconButton>
              ))}
            {!isNewScope && (
              <IconButton aria-label="delete" color="secondary" onClick={handleDelete}>
                <FiTrash2 />
              </IconButton>
            )}
          </Box>
        </Stack>
      )}
    </Window>
  );
};

export default ScopeDetail;
